import React, { useState } from "react";
import { useForm, useFormState } from "react-hook-form";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  SafeAreaView,
  ScrollView,
  KeyboardAvoidingView,
} from "react-native";
import { useDispatch } from "react-redux";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import FastImage from "../../../common/FastImage";
import CommonModal from "../../../commonComponents/commonModal";
import {Button} from '../../../components/core/Button';
import {Input} from '../../../components/core/Input';
import Header from "../../../commonComponents/Header";
import { RegEx } from "../../../utils/commonMethods";
import { errorBlock } from "../../../utils/images";
import { Network } from "../../../utils/network";
import { getBankDetails } from "../../Profile/redux/profile.action";
import {globalConst} from "../../../utils/globalConstant";

const KYC = ({ navigation }) => {
  const {
    control,
    formState: { errors, isValid, isSubmitting },
    handleSubmit,
    reset,
    watch,
  } = useForm({ mode: "onChange" });
  const { isDirty } = useFormState({
    control,
  });
  const dispatch = useDispatch();
  const accountNumber = watch("accountNumber");
  const accountNumberCheck = watch("accountNumberCheck");
  const [isShowBottomSheet, setIsShowBottomsheet] = useState(false);
  const [respError, setResponseError] = useState("");
  const [apiSuccess, setApiSuccess] = useState("");

  const onClickKycSubmit = async (details, e) => {
    e.preventDefault();
    if (isDirty) {
      const data = {
        accountNumber: details.accountNumberCheck,
        ifsc: details.ifsc,
        //name: details.accountHolderName,
        pan: details.PANNO,
      };

      const res = await Network.addBankDetails(data);
      if (!res?.data?.success) {
        dispatch(getBankDetails());
        setResponseError(res?.data?.error);

        setIsShowBottomsheet(true);
      } else {
        dispatch(getBankDetails());
        navigation.pop();

        setApiSuccess("Your KYC verification has been successfull!");
      }
    } else {
      setResponseError("Nothing to Update");

      setIsShowBottomsheet(true);
    }
  };
  return (
    <SafeAreaView style={[globalStyle.pageContainer, { flexGrow: 1 }]}>
      <KeyboardAvoidingView behavior="height" keyboardVerticalOffset={0}>
        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{ flexGrow: 1 }}
        >
          <Header
            isInternalPage={false}
            navigation={navigation}
            pageName={"KYC Verification"}
          />
          <View style={{ paddingHorizontal: 14, flex: 1, marginTop: 38 }}>
            <View style={{ marginBottom: 50 }}>
              <Text style={styles.labelHighlight}>PAN Card</Text>
              <Text style={styles.labelHighlightSubText}>
                Enter your 10 digit PAN card no for verification purposes
              </Text>
              <Text style={styles.label}>PAN NO</Text>
              <Input
                name="PANNO"
                placeholder="Enter your 10-digit PAN"
                control={control}
                rules={{
                  required: "Please enter IFSC code",
                  pattern: {
                    value: RegEx.pan,
                    message: "Please enter a valid PAN",
                  },
                }}
                fullWidth={true}
                formatter="pan"
              />
              {errors?.PANNO?.type === "required" && (
                <Text style={globalStyle.errorText}>
                  {errors?.PANNO.message}
                </Text>
              )}
              {errors?.PANNO?.type === "pattern" && (
                <Text style={globalStyle.errorText}>
                  {errors?.PANNO?.message}
                </Text>
              )}
            </View>
            <Text style={styles.labelHighlight}>Bank Details</Text>
            <Text style={styles.labelHighlightSubText}>
              Please make sure that your bank details are matching with your KYC
              details for a hassel-free withdrawal process. We'll deposit 1 in
              order to verify your bank account.
            </Text>
            <View>
              <Text style={styles.label}>IFSC CODE</Text>
              <Input
                name="ifsc"
                placeholder="Write IFSC Code here"
                control={control}
                rules={{
                  required: "Please enter IFSC code",
                  pattern: {
                    value: RegEx.ifsc,
                    message: "Please enter a valid IFSC",
                  },
                }}
                fullWidth={true}
                formatter="ifsc"
              />
              {errors?.ifsc?.type === "required" && (
                <Text style={globalStyle.errorText}>
                  {errors?.ifsc.message}
                </Text>
              )}
              {errors?.ifsc?.type === "pattern" && (
                <Text style={globalStyle.errorText}>
                  {errors?.ifsc?.message}
                </Text>
              )}
            </View>
            <View style={{ marginTop: 25 }}>
              <Text style={styles.label}>ACCOUNT NO</Text>
              <Input
                name="accountNumber"
                placeholder="Please enter a valid Account Number"
                control={control}
                rules={{
                  required: "Please enter account number",
                  pattern: {
                    value: RegEx.accountNum,
                    message: "Please enter a valid Account Number",
                  },
                }}
                fullWidth={true}
                numeric={true}
              />
              {errors?.accountNumber?.type === "required" && (
                <Text style={globalStyle.errorText}>
                  {errors?.accountNumber.message}
                </Text>
              )}
              {errors?.accountNumber?.type === "pattern" && (
                <Text style={globalStyle.errorText}>
                  {errors?.accountNumber?.message}
                </Text>
              )}
            </View>
            <View style={{ marginTop: 25 }}>
              <Text style={styles.label}>CONFIRM ACCOUNT NO</Text>
              <Input
                name="accountNumberCheck"
                placeholder="Re-enter Account Number"
                control={control}
                rules={{
                  required: true,
                  validate: {
                    equal: (value) => {
                      return value === accountNumber;
                    },
                  },
                }}
                fullWidth={true}
                numeric={true}
              />
              {accountNumberCheck !== accountNumber ? (
                <Text style={globalStyle.errorText}>
                  The account numbers don't match
                </Text>
              ) : null}
            </View>
            <View
              style={{ justifyContent: "flex-end", flex: 1, paddingVertical: 40, paddingBottom: 100 }}
            >
              <Text style={styles.note}>
                Before submitting, please double-check your details else your
                withdrawl gets delayed. Also once details are submitted &
                verified you cannot change the PAN Number.
              </Text>
            </View>
            {apiSuccess ? <Text>{apiSuccess ? apiSuccess : ""}</Text> : null}
          </View>
          <View style={{...globalStyle.bottomAbsBtnBar, borderTopWidth: 0}}>
            <Button
              variant="primary"
              onPress={handleSubmit(onClickKycSubmit)}
              style={[{ marginRight: 10, paddingHorizontal: 15 }]}
            >
              Submit Details
            </Button>
          </View>
        </ScrollView>
        <CommonModal
          onModalCallBack={() => setIsShowBottomsheet(false)}
          customModalStyle={[globalStyle.modalView]}
          showModal={isShowBottomSheet}
        >
          <View
            style={{
              width: Width.width,
              paddingHorizontal: 17,
              paddingVertical: 17,
            }}
          >
            <View style={{ alignItems: "center" }}>
              <FastImage
                style={styles.errorStyle}
                source={errorBlock()}
              />
              <Text>KYC Verification Failed</Text>
              <Text style={{ marginBottom: 20 }}>{respError}</Text>
            </View>

            <Button
              variant="primary"
              onPress={() => {
                setTimeout(() => {
                  setIsShowBottomsheet(false);
                }, globalConst?.buttonTimer);
              }}
            >
              Retry
            </Button>
          </View>
        </CommonModal>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

export default KYC;

const styles = StyleSheet.create({
  labelHighlight: {
    ...globalFontStyle.appFontHeading,
    color: Colors.black,
  },
  labelHighlightSubText: {
    ...globalFontStyle.appFontSubText,
    color: Colors.black,
    marginTop: 8,
    marginBottom: 35,
  },
  label: {
    ...globalFontStyle.appFontSubText,
    color: Colors.grey1,
  },
  note: {
    ...globalFontStyle.appFontSubText,
    color: Colors.black,
    textAlign: "center",
  },
  errorStyle: {
    width: 50,
    height: 50,
    marginBottom: 15,
  },
});
